import React from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';

const HelpModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  // Utiliser un Portal pour rendre le modal en dehors de la hiérarchie DOM
  return ReactDOM.createPortal(
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-6 bg-black/80 backdrop-blur-md"
      onClick={onClose}
      style={{ isolation: 'isolate' }}
    >
      <div 
        className="relative w-full max-w-6xl min-h-[50vh] max-h-[85vh] overflow-y-auto rounded-3xl bg-gradient-to-br from-[#1a1f2e] to-[#252b3d] border-2 border-white/30 shadow-[0_30px_100px_rgba(111,66,234,0.7)] animate-fade-scale-in"
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'relative', zIndex: 10000 }}
      >
        {/* Halo subtle derrière le header */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[200px] h-[200px] bg-[#6F42EA] opacity-[0.15] blur-[100px] rounded-full pointer-events-none" />
        
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#3B48EE]/10 via-transparent to-[#6F42EA]/5 pointer-events-none rounded-3xl" />
        
        {/* Content */}
        <div className="relative z-10">
          {/* Header */}
          <div className="flex items-center justify-between p-10 pb-6 border-b-2 border-white/25">
            <h2 className="text-4xl font-bold text-white tracking-wide drop-shadow-[0_6px_20px_rgba(255,255,255,0.2)]">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="flex-shrink-0 p-4 rounded-2xl bg-white/20 hover:bg-white/30 transition-all border-2 border-white/30 backdrop-blur-md group shadow-xl"
            >
              <X className="w-7 h-7 text-white group-hover:text-white" strokeWidth={2.5} />
            </button>
          </div>
          
          {/* Body */}
          <div className="p-10 pt-8 relative z-10">
            <div className="relative z-10 text-white text-xl leading-loose">
              {children}
            </div>
          </div>
        </div>
      </div>
      
      {/* Animation CSS */}
      <style>{`
        @keyframes fadeScaleIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .animate-fade-scale-in {
          animation: fadeScaleIn 250ms ease-out;
        }
      `}</style>
    </div>,
    document.body
  );
};

export default HelpModal;
